import { LocalService } from './../storage/localService';
import { SessionStorageService } from './../storage/sessionStorage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map,filter, pluck  } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TipoCambioService {

  message: Observable<any>;
  idEmpresa_Factor : any;
  readonly urlBase =  environment.rutaBase;  
  header : HttpHeaders;

  constructor(   private http: HttpClient , 
                 private accesoService :AccesoService,
                 private sessionStorageService: SessionStorageService,
                 private localService : LocalService) {                    
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }

  obtenerTipoDeCambio(FInicial : any , FFinal : any , Fuente : string) {  
    let headers = this.header;
    return this.http.get(`${this.urlBase}/configuraciones/tipo-cambio?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroRegistro=100&NumeroPagina=1&FechaInicial=${FInicial}&FechaFinal=${FFinal}&Fuente=${Fuente}`,{headers}).pipe(
      map((data) => {
        return data;
      })
    );
  }

  obtenerTipoCambio() {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/configuraciones/tipo-cambio-activo?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  crearTipoDeCambio(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/configuraciones/tipo-cambio?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  editarTipoDeCambio(id:number , data: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/configuraciones/tipo-cambio/${id}?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }
}